exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form{position:relative}.login-form__forgot-password{display:block;width:120px;margin:0 auto;margin-top:22px;text-align:center;font-size:14px;line-height:20px;font-weight:500;color:#37b;border:none;background-color:rgba(0,0,0,0)}.login-form__forgot-password:disabled{opacity:.6}@media(min-width: 768px){.login-form__forgot-password{width:140px;margin-top:28px;font-size:17px;line-height:24px;cursor:pointer}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/login-page/login/login-form/style.scss
// module id = 1354
// module chunks = 57